import AuthStore from './AuthStore'
export default new AuthStore()
